import { TextField } from "@mui/material";
import * as React from "react";
import { Controller } from "react-hook-form";
import { IInput } from "../types/dataForm/types";

export interface IInputText extends IInput {
  accept?: string;
  setValue?: any;
  type?: React.InputHTMLAttributes<unknown>["type"];
  minRows?: number;
  maxRows?: number;
  readonly?: boolean;
  size?: "medium" | "small";
  form: any;
}

export default function InputText({
  name,
  form,
  label,
  type = "text",
  readonly = false,
  size = "small",
  mb = 2,
  minRows = 3,
  maxRows = 6,
}: IInputText) {
  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          size={size}
          disabled={readonly}
          minRows={minRows}
          maxRows={maxRows}
          InputLabelProps={{ shrink: true }}
          multiline={type === "textarea"}
          type={type === "textarea" ? "text" : type}
          sx={{ mb, width: "100%" }}
          helperText={error ? error.message : null}
          error={!!error}
          onChange={onChange}
          value={value || ""}
          label={label}
        />
      )}
    />
  );
}
